export const LT_BUTTON_VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  LINK: 'link',
  ERROR: 'error'
} as const;

export type ButtonVariant = (typeof LT_BUTTON_VARIANTS)[keyof typeof LT_BUTTON_VARIANTS];

export const LT_BUTTON_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
} as const;

export type ButtonSize = (typeof LT_BUTTON_SIZES)[keyof typeof LT_BUTTON_SIZES];
